import { useQuery } from '@tanstack/react-query'
import { patientsApi, type PatientRecord } from '@/api/patientsApi'
import { useTenant } from '@/providers/TenantProvider'

/**
 * The patient page's record (z8nrz7g57g): clinical facts and donors read from
 * the patient's forms, and the history of the patient, their runs and products.
 * Also read by the product page for the recipient. Works for an MRN with no
 * Patient row, as the page does.
 */
export function usePatientRecord(mrn: string | null | undefined) {
  const { selectedTenantId } = useTenant()
  return useQuery<PatientRecord>({
    queryKey: ['patients', 'record', selectedTenantId, mrn],
    enabled: !!mrn && !!selectedTenantId,
    queryFn: () => patientsApi.record(mrn as string),
  })
}
